import React from "react";
import { Link } from "react-router-dom";

export function AuthShell({ eyebrow, title, subtitle, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10" data-testid="auth-brand">
          <div className="w-10 h-10 bg-amber flex items-center justify-center">
            <span className="font-display text-3xl text-[#0B0D12] leading-none">G</span>
          </div>
          <div>
            <div className="font-display text-2xl tracking-widest text-white leading-none">GRIDIRON OS</div>
            <div className="font-condensed text-[9px] tracking-[0.4em] uppercase text-amber mt-1">The Program Operating System</div>
          </div>
        </Link>
        <div className="mb-8">
          <div className="text-[10px] font-condensed tracking-[0.4em] uppercase text-amber mb-3">{eyebrow}</div>
          <div className="font-display text-5xl tracking-wider text-white uppercase leading-none">{title}</div>
          {subtitle && <p className="text-slate-400 text-sm mt-3">{subtitle}</p>}
        </div>
        {children}
        <div className="mt-8 pt-6 border-t border-surface-3 text-xs text-slate-500">
          Remembered it? <Link to="/login" className="text-amber hover:underline" data-testid="link-back-to-login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}

export function AuthError({ children, testid = "auth-error" }) {
  if (!children) return null;
  return (
    <div className="text-sm text-red-400 border-l-2 border-red-500 pl-3 py-2 bg-red-500/5" data-testid={testid}>
      {children}
    </div>
  );
}

export const authInputClass = "mt-2 bg-surface border-surface-3 focus:border-amber focus-visible:ring-amber h-11 text-sm";
export const authButtonClass = "w-full h-12 bg-amber hover:bg-amber-600 text-[#0B0D12] font-condensed uppercase tracking-[0.25em] text-sm rounded-none";
